<router-outlet />

<!-- @if (unauthorizedService.isUnauthorized()) {
  <app-token-expired />
} -->
